import { Button } from './CategoryHeader';
import { CategoryHeader, Title } from './CategoryHeader.views';
CategoryHeader.displayName = "CategoryHeaderBase";
Button.displayName = "CategoryHeader.Button";
Title.displayName = "CategoryHeader.Title";
export { CategoryHeader as default, Button, Title };